import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceTimeRequestsService} from "../../services/service-time-requests.service";

export class PricePlanCalendarEventDialogViewComponent implements IController {
  programId: any;
  eventRef: any;
  day: any;
  query: any;


  config: any;
  event: any;
  isLoading: any;
  start: any;
  end: any;
  startTime: any;
  endTime: any;
  dateSelectOptions: any;

  public cancel: Function;

  constructor(private $mdDialog, private pricePlanConstant, private serviceTimeRequestsService: ServiceTimeRequestsService, private moment) {
  }

  $onInit() {
    this.config = angular.copy(this.pricePlanConstant.serviceTime);
    this.event = angular.copy(this.eventRef);
    this.isLoading = false;

    this.start = this.event.start.toDate();
    this.end = this.event.end.toDate();

    this.startTime = this.convertMomentToTime(this.event.start);
    this.endTime = this.convertMomentToTime(this.event.end);

    this.createDateSelectOptions();
    this.cancel = this.$mdDialog.cancel;
  }

  ok() {
    this.event.start = this.updateEventDateTime(this.start, this.startTime);
    this.event.end = this.updateEventDateTime(this.end, this.endTime);

    this.event.$$day.slot.from = this.updateSlotTime(this.startTime);
    this.event.$$day.slot.to = this.updateSlotTime(this.endTime);

    let dayCopy = angular.copy(this.day);

    dayCopy.dayChunks.splice(this.eventRef.$$day.slotIndex, 1);
    dayCopy.dayChunks.push({
      from: this.event.$$day.slot.from,
      to: this.event.$$day.slot.to,
      enabled: _.get(this.event.$$day.slot, 'enabled'),
      commission: _.get(this.event.$$day.slot, 'commission'),
      priceExtra: _.get(this.event.$$day.slot, 'priceExtra'),
      priceFactor: _.get(this.event.$$day.slot, 'priceFactor'),
      label: _.get(this.event.$$day.slot, 'label')
    });

    this.isLoading = true;

    const request = this.eventRef.$$day.isSpecialDay ? 'updateCreateSpecialDay' : 'updateCreateServiceTime';
    this.serviceTimeRequestsService[request](this.programId, dayCopy, this.query).then(
      (data) => {
        this.isLoading = false;
        this.$mdDialog.hide(data);
      }
    ).catch(err => this.$mdDialog.cancel(err));

  }

  convertMomentToTime(moment) {
    return {
      hour: moment.hour(),
      minute: moment.minute()
    };
  }

  updateEventDateTime(date, time) {
    let newDate = this.moment(date);

    newDate.hour(time.hour);
    newDate.minute(time.minute);

    return newDate;
  }

  updateSlotTime(time) {
    const HOUR = 60,
      minutes = time.minute > 0 ? HOUR / time.minute : time.minute,
      factored = minutes > 0 ? 1 / minutes : minutes;

    return time.hour + factored;
  }

  createDateSelectOptions() {
    // create options for time select boxes (this will be removed in favor of mdDatetime picker when it becomes available).
    this.dateSelectOptions = {
      hours: [],
      minutes: []
    };

    const steps = this.pricePlanConstant.serviceTime.steps;

    //Hours
    for (let hour = 0; hour <= 23; hour = hour + steps.hour) {
      this.dateSelectOptions.hours.push(hour);
    }

    //Minutes
    for (let minute = 0; minute <= 59; minute = minute + steps.minute) {
      this.dateSelectOptions.minutes.push(minute);
    }
  }

  remove() {
    this.isLoading = true;
    _.set(this.event.$$day.slot, 'enabled', undefined);

    this.changeEventColors();

    const dayCopy = angular.copy(this.day);
    dayCopy.dayChunks.splice(this.eventRef.$$day.slotIndex, 1);

    const request = this.event.$$day.isSpecialDay ? 'updateCreateSpecialDay' : 'updateCreateServiceTime';
    this.serviceTimeRequestsService[request](this.programId, dayCopy, this.query).then(
      (data) => {
        this.isLoading = false;
        this.$mdDialog.hide(data);
      }
    ).catch(err => this.$mdDialog.cancel(err));

  }

  changeEventColors() {
    const state = this.event.$$day.slot.enabled ? this.config.events.states[3] : this.config.events.states[2],
      colorScheme = this.serviceTimeRequestsService.getEventColorScheme(this.event.$$day.isSpecialDay, state);
    _.merge(this.event, colorScheme);
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanCalendarEventDialogView', {
    bindings: {
      programId: '<',
      eventRef: '<',
      day: '<',
      query: '<',
      onHide: '&',
      onCancel: '&'
    },
    template: require('./price-plan-calendar-event-dialog-view.html').default,
    controller: PricePlanCalendarEventDialogViewComponent

  });
